/* eslint-disable unicorn/prefer-module */
/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
import { useState } from "react";
import toast from "react-hot-toast";
import { getContratos, log, registrarCredito, updateContrato, updateOportunidad, updateOportunidadBTL } from "../../../utils";
import { client } from "../../../utils/supabase";

export const useVFEditModal = ({ todasOportunidades, setTodasOportunidades, pais, getUFValue, userId }) => {
  const [showModal, setShowModal] = useState(false);
  const [oportunidadEditada, setOportunidadEditada] = useState(null);
  const [formData, setFormData] = useState({
    facturanumero: "",
    facturafecha: "",
    plazocobro: "",
    facturafechacobro: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [registrarComoCredito, setRegistrarComoCredito] = useState(false);

  const handleOpenModal = (oportunidad) => {
    setOportunidadEditada(oportunidad);
    setFormData({
      facturanumero: oportunidad.facturanumero || "",
      facturafecha: oportunidad.facturafecha
        ? new Date(oportunidad.facturafecha).toISOString().split("T")[0]
        : "",
      plazocobro: oportunidad.plazocobro
        ? new Date(oportunidad.plazocobro).toISOString().split("T")[0]
        : "",
      facturafechacobro: oportunidad.facturafechacobro
        ? new Date(oportunidad.facturafechacobro).toISOString().split("T")[0]
        : "",
    });
    setShowModal(true);
    setError(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setOportunidadEditada(null);
    setFormData({ facturanumero: "", facturafecha: "", facturafechacobro: "" });
    setError(null);
    setLoading(false);
    setRegistrarComoCredito(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveChanges = async () => {
    if (!oportunidadEditada) return;

    // Validaciones
    if (!formData.facturanumero.trim()) {
      setError("El número de factura es obligatorio");
      return;
    }
    if (!formData.facturafecha) {
      setError("La fecha de factura es obligatoria");
      return;
    }

    // Validar que plazocobro >= facturafecha
    if (formData.plazocobro && formData.plazocobro < formData.facturafecha) {
      setError("La fecha proyectada no puede ser anterior a la fecha de factura");
      return;
    }

    // Validar que facturafechacobro >= facturafecha
    if (formData.facturafechacobro && formData.facturafechacobro < formData.facturafecha) {
      setError("La fecha real de cobro no puede ser anterior a la fecha de factura");
      return;
    }

    // Contratos tipo pauta: warning si no hay edificios asignados (no bloquea)

    // Nota: un mismo número de factura puede estar asociado a múltiples servicios/edificios
    // (ej: gestión PSd I y PSd II en una misma factura, o OPEX + gestión de un edificio)

    try {
      setLoading(true);

      const updatedOportunidad = {
        facturafecha: formData.facturafecha, // "2025-12-10"
        facturafechacobro: formData.facturafechacobro || null,
        plazocobro: formData.plazocobro || null,
        facturanumero: formData.facturanumero,
        updated_at: new Date().toISOString(),
      };

      if (oportunidadEditada.type === "contrato") {
        // Contratos: actualizar el mes específico dentro del JSONB meses
        const contratosRaw = await getContratos({ pais });
        const contrato = contratosRaw.find((c) => c.id === oportunidadEditada.contrato_id);
        if (!contrato) throw new Error("Contrato no encontrado");
        const updatedMeses = [...(contrato.meses || [])];
        updatedMeses[oportunidadEditada.mes_index] = {
          ...updatedMeses[oportunidadEditada.mes_index],
          facturafecha: updatedOportunidad.facturafecha,
          facturanumero: updatedOportunidad.facturanumero,
          plazocobro: updatedOportunidad.plazocobro,
          facturafechacobro: updatedOportunidad.facturafechacobro,
        };
        await updateContrato({ id: contrato.id, contrato: { meses: updatedMeses } });
      } else if (oportunidadEditada.type === "HW-CAPEX") {
        // HW-CAPEX: actualizar entry en detalle_pagos_hardware del negocio
        const { data: negocio } = await client
          .from("negocios_carteleria").select("detalle_pagos_hardware").eq("id", oportunidadEditada.negocio_id).single();
        const detalle = typeof negocio.detalle_pagos_hardware === "string"
          ? JSON.parse(negocio.detalle_pagos_hardware || "[]") : (negocio.detalle_pagos_hardware || []);
        detalle[oportunidadEditada.entry_index] = {
          ...detalle[oportunidadEditada.entry_index],
          facturafecha: updatedOportunidad.facturafecha,
          facturanumero: updatedOportunidad.facturanumero,
          plazocobro: updatedOportunidad.plazocobro,
          facturafechacobro: updatedOportunidad.facturafechacobro,
        };
        await client.from("negocios_carteleria").update({ detalle_pagos_hardware: detalle }).eq("id", oportunidadEditada.negocio_id);
      } else if (oportunidadEditada.type === "HW-OPEX" || oportunidadEditada.type === "Gestión") {
        // OPEX/Gestión: actualizar o crear entry en meses_facturacion JSONB
        const tipoFact = oportunidadEditada.type === "HW-OPEX" ? "opex" : "gestion";
        const { data: negocio } = await client
          .from("negocios_carteleria").select("meses_facturacion").eq("id", oportunidadEditada.negocio_id).single();
        const mesesFact = negocio.meses_facturacion
          ? (typeof negocio.meses_facturacion === "string" ? JSON.parse(negocio.meses_facturacion) : negocio.meses_facturacion)
          : [];
        const existingIdx = mesesFact.findIndex(
          (mf) => mf.mes === oportunidadEditada.mes && mf.ano === oportunidadEditada.ano && mf.tipo === tipoFact
        );
        const entry = {
          mes: oportunidadEditada.mes, ano: oportunidadEditada.ano, tipo: tipoFact,
          facturafecha: updatedOportunidad.facturafecha,
          facturanumero: updatedOportunidad.facturanumero,
          plazocobro: updatedOportunidad.plazocobro,
          facturafechacobro: updatedOportunidad.facturafechacobro,
        };
        if (existingIdx >= 0) {
          mesesFact[existingIdx] = { ...mesesFact[existingIdx], ...entry };
        } else {
          mesesFact.push(entry);
        }
        await client.from("negocios_carteleria").update({ meses_facturacion: mesesFact }).eq("id", oportunidadEditada.negocio_id);

        // Sincronizar tipo opuesto (opex↔gestion) si no tiene factura
        const tipoOpuesto = tipoFact === "opex" ? "gestion" : "opex";
        const tipoOpuestoLabel = tipoFact === "opex" ? "Gestión" : "HW-OPEX";
        const entradaOpuesta = mesesFact.find(
          (mf) => mf.mes === oportunidadEditada.mes && mf.ano === oportunidadEditada.ano && mf.tipo === tipoOpuesto
        );
        if (entradaOpuesta && (!entradaOpuesta.facturanumero || !entradaOpuesta.facturanumero.trim())) {
          toast(
            (t) => (
              <div style={{ fontSize: "0.85rem" }}>
                <div style={{ marginBottom: 8 }}>
                  ¿Aplicar factura <strong>{updatedOportunidad.facturanumero}</strong> también a{" "}
                  <strong>{tipoOpuestoLabel}</strong> del mismo mes?
                </div>
                <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                  <button
                    onClick={() => toast.dismiss(t.id)}
                    style={{
                      padding: "4px 12px",
                      fontSize: "0.78rem",
                      border: "1px solid #ccc",
                      borderRadius: 4,
                      background: "#fff",
                      cursor: "pointer",
                    }}
                  >
                    No
                  </button>
                  <button
                    onClick={async () => {
                      toast.dismiss(t.id);
                      try {
                        const opIdx = mesesFact.findIndex(
                          (mf) =>
                            mf.mes === oportunidadEditada.mes &&
                            mf.ano === oportunidadEditada.ano &&
                            mf.tipo === tipoOpuesto
                        );
                        if (opIdx >= 0) {
                          mesesFact[opIdx] = {
                            ...mesesFact[opIdx],
                            facturafecha: updatedOportunidad.facturafecha,
                            facturanumero: updatedOportunidad.facturanumero,
                            plazocobro: updatedOportunidad.plazocobro,
                            facturafechacobro: updatedOportunidad.facturafechacobro,
                          };
                          await client
                            .from("negocios_carteleria")
                            .update({ meses_facturacion: mesesFact })
                            .eq("id", oportunidadEditada.negocio_id);
                          // Actualizar la fila opuesta en el state local
                          const opId =
                            tipoFact === "opex"
                              ? `gestion-${oportunidadEditada.negocio_id}-${oportunidadEditada.mes_index}`
                              : `hw-opex-${oportunidadEditada.negocio_id}-${oportunidadEditada.mes_index}`;
                          setTodasOportunidades((prev) =>
                            prev.map((op) =>
                              op.id === opId
                                ? {
                                    ...op,
                                    facturafecha: updatedOportunidad.facturafecha,
                                    facturanumero: updatedOportunidad.facturanumero,
                                    plazocobro: updatedOportunidad.plazocobro,
                                    facturafechacobro: updatedOportunidad.facturafechacobro,
                                  }
                                : op
                            )
                          );
                          toast.success(`Factura aplicada a ${tipoOpuestoLabel}`);
                        }
                      } catch (err) {
                        console.error("Error sincronizando tipo opuesto:", err);
                        toast.error("Error al sincronizar");
                      }
                    }}
                    style={{
                      padding: "4px 12px",
                      fontSize: "0.78rem",
                      border: "none",
                      borderRadius: 4,
                      background: "#2c3e50",
                      color: "#fff",
                      cursor: "pointer",
                      fontWeight: 600,
                    }}
                  >
                    Sí
                  </button>
                </div>
              </div>
            ),
            { duration: 5000 }
          );
        }
      } else if (oportunidadEditada.type === "BTL") {
        await updateOportunidadBTL({ id: oportunidadEditada.id, oportunidad: updatedOportunidad });
      } else {
        await updateOportunidad({ id: oportunidadEditada.id, oportunidad: updatedOportunidad });
      }

      // Recalcular mes/ano derivados si la fecha de factura cambió
      let derivedFields = {};
      if (updatedOportunidad.facturafecha) {
        const [y, mStr] = updatedOportunidad.facturafecha.split("-");
        derivedFields = { mes: mStr, ano: y };
      }
      setTodasOportunidades((prev) =>
        prev.map((op) => {
          if (op.id !== oportunidadEditada.id) return op;
          const updated = { ...op, ...updatedOportunidad, ...derivedFields };
          // Recalcular importe si la moneda es UF y cambió facturafecha
          if (updatedOportunidad.facturafecha && op.valor_cuota && op.moneda_cuota === "UF") {
            updated.importe = op.valor_cuota * (getUFValue(updatedOportunidad.facturafecha) || 1);
          }
          return updated;
        })
      );

      // Registrar crédito si se marcó la opción (contrato sin edificios)
      if (registrarComoCredito && oportunidadEditada.type === "contrato" && oportunidadEditada.client_id) {
        try {
          await registrarCredito({
            clientId: oportunidadEditada.client_id,
            pais,
            tipo: "carga",
            monto: oportunidadEditada.importe || 0,
            moneda: oportunidadEditada.moneda_dolar ? "USD" : (pais === "Peru" ? "PEN" : "CLP"),
            referenciaId: String(oportunidadEditada.contrato_id),
            referenciaTipo: "sales_contratos",
            descripcion: `Factura ${formData.facturanumero} — crédito anticipado`,
            usuarioId: parseInt(userId, 10),
          });
          toast.success("Crédito registrado para el cliente");
        } catch (creditError) {
          log.error("registrarCredito", creditError);
          toast.error("Factura guardada, pero hubo un error al registrar el crédito");
        }
      }

      toast.success("Factura actualizada correctamente");
      handleCloseModal();
    } catch (error) {
      if (error.code === "23505") {
        setError("El número de factura ya existe");
      } else {
        setError("Hubo un error al actualizar la oportunidad, prueba de nuevo.");
      }
      log.error("handleSaveChanges", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClearFactura = async () => {
    if (!oportunidadEditada) return;
    try {
      setLoading(true);
      const nullFactura = { facturafecha: null, facturafechacobro: null, plazocobro: null, facturanumero: null, updated_at: new Date().toISOString() };

      if (oportunidadEditada.type === "contrato") {
        const contratosRaw = await getContratos({ pais });
        const contrato = contratosRaw.find((c) => c.id === oportunidadEditada.contrato_id);
        if (!contrato) throw new Error("Contrato no encontrado");
        const updatedMeses = [...(contrato.meses || [])];
        updatedMeses[oportunidadEditada.mes_index] = {
          ...updatedMeses[oportunidadEditada.mes_index],
          facturafecha: null, facturanumero: null, plazocobro: null, facturafechacobro: null,
        };
        await updateContrato({ id: contrato.id, contrato: { meses: updatedMeses } });
      } else if (oportunidadEditada.type === "HW-CAPEX") {
        const { data: negocio } = await client
          .from("negocios_carteleria").select("detalle_pagos_hardware").eq("id", oportunidadEditada.negocio_id).single();
        const detalle = typeof negocio.detalle_pagos_hardware === "string"
          ? JSON.parse(negocio.detalle_pagos_hardware || "[]") : (negocio.detalle_pagos_hardware || []);
        detalle[oportunidadEditada.entry_index] = {
          ...detalle[oportunidadEditada.entry_index],
          facturafecha: null, facturanumero: null, plazocobro: null, facturafechacobro: null,
        };
        await client.from("negocios_carteleria").update({ detalle_pagos_hardware: detalle }).eq("id", oportunidadEditada.negocio_id);
      } else if (oportunidadEditada.type === "HW-OPEX" || oportunidadEditada.type === "Gestión") {
        const tipoFact = oportunidadEditada.type === "HW-OPEX" ? "opex" : "gestion";
        const { data: negocio } = await client
          .from("negocios_carteleria").select("meses_facturacion").eq("id", oportunidadEditada.negocio_id).single();
        const mesesFact = negocio.meses_facturacion
          ? (typeof negocio.meses_facturacion === "string" ? JSON.parse(negocio.meses_facturacion) : negocio.meses_facturacion)
          : [];
        const updatedMesesFact = mesesFact.filter(
          (mf) => !(mf.mes === oportunidadEditada.mes && mf.ano === oportunidadEditada.ano && mf.tipo === tipoFact)
        );
        await client.from("negocios_carteleria").update({ meses_facturacion: updatedMesesFact }).eq("id", oportunidadEditada.negocio_id);
      } else if (oportunidadEditada.type === "BTL") {
        await updateOportunidadBTL({ id: oportunidadEditada.id, oportunidad: nullFactura });
      } else {
        await updateOportunidad({ id: oportunidadEditada.id, oportunidad: nullFactura });
      }

      setTodasOportunidades((prev) =>
        prev.map((op) =>
          op.id !== oportunidadEditada.id
            ? op
            : { ...op, facturanumero: null, facturafecha: null, plazocobro: null, facturafechacobro: null }
        )
      );
      toast.success("Factura eliminada correctamente");
      handleCloseModal();
    } catch (error) {
      setError("Hubo un error al eliminar la factura, prueba de nuevo.");
      log.error("handleClearFactura", error);
    } finally {
      setLoading(false);
    }
  };

  // Otras oportunidades que ya usan el mismo número de factura (info, no bloqueo)
  const otrasConMismaFactura = formData.facturanumero.trim()
    ? todasOportunidades.filter(
      (op) =>
        op.facturanumero === formData.facturanumero.trim() &&
        op.id !== (oportunidadEditada?.id || null)
    )
    : [];

  const warnSinEdificios =
    oportunidadEditada?.type === "contrato" && !oportunidadEditada?.edificios_ids;

  return {
    showModal,
    oportunidadEditada,
    formData,
    loading,
    error,
    warnSinEdificios,
    registrarComoCredito,
    setRegistrarComoCredito,
    otrasConMismaFactura,
    handleOpenModal,
    handleCloseModal,
    handleInputChange,
    handleSaveChanges,
    handleClearFactura,
  };
};
